// extracted by mini-css-extract-plugin
export default {"button_container":"ButtonMobile_button_container__XxLqr","button_label":"ButtonMobile_button_label__L5te-","button_icon_start":"ButtonMobile_button_icon_start__MNIXT"};